import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/img/home/home-icon-1.png'
import _imports_1 from '../assets/img/home/home-icon-hover-1.png'
import _imports_2 from '../assets/img/home/home-icon-2.png'
import _imports_3 from '../assets/img/home/home-icon-hover-2.png'
import _imports_4 from '../assets/img/home/home-icon-3.png'
import _imports_5 from '../assets/img/home/home-icon-hover-3.png'
import _imports_6 from '../assets/img/home/home-icon-4.png'
import _imports_7 from '../assets/img/home/home-icon-hover-4.png'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = ["src", "onLoad"]
const _hoisted_3 = { class: "module2" }
const _hoisted_4 = { class: "centent-l" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "title" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "title" }
const _hoisted_12 = ["innerHTML"]

import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';
import Consult from '@/components/consult.vue';
import Footer from '@/components/footer.vue';
import News from '@/components/news.vue';
import axios from 'axios';
// @ts-ignore
import { apiUrl } from '@/assets/js/global'
// 获取 store 实例

export default /*@__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const store = useStore();
// banner列表
const banners: any = ref([{
  "url": "p-1741314430184-490458.jpg",
  "title": "",
  "describe": ""
}])
// 新闻列表
const news = ref([])
// 生态系统列表
const businessList: any = ref([])
// 获取banner图
const getBanner = () => {
  axios.post(apiUrl + '/api/banners/list', {
    code: 'HOME'
  }).then((res: any) => {
    if (res.data?.result.length == 0) return;
    banners.value = res.data?.result[0].urls
  });
}
// 获取品牌咨询列表
const getNews = () => {
  axios.get(apiUrl + '/api/brand_consult/list',).then((res: any) => {
    news.value = res.data?.result;
    news.value.forEach((item: any) => {
      const [year, month, day] = item?.date.split('-');
      item.time = `${year}-${month}`;
      item.day = `${day}`;
    })
  });
}
// 获取生态系统列表
const getBusinessList = () => {
  axios.get(apiUrl + '/api/business/list',).then((res: any) => {
    businessList.value = res.data?.result;
  });
}
// 图片的 ref 数组
const imageRefs:any = ref([]);
// 设置图片的 ref
const setImageRef = (el:any, index:number) => {
  if (el) {
    imageRefs.value[index] = el;
  }
};
// 图片加载完成后的回调
const onImageLoad = (index:number) => {
  const img = imageRefs.value[index];
  if (img) {
    store.commit('setbannerHeight',img.height - 110);
    store.commit('setnavBgColor','rgb(0 0 0 / 0%)');
    
  }
};
onMounted(() => {
  
  window.scrollTo(0, 0);
  getBanner();
  getNews();
  getBusinessList()
});

return (_ctx: any,_cache: any) => {
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_carousel, { class: "banner-box" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banners.value, (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            loading: "lazy",
            src: _unref(apiUrl) + '/images/' + item.url,
            ref_for: true,
            ref: (el) => setImageRef(el, index),
            onLoad: ($event: any) => (onImageLoad(index))
          }, null, 40, _hoisted_2))
        }), 256))
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { justify: "center" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 20 }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "title" }, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, "多元布局 全面发展"),
                _createElementVNode("span", null, "ENTERPRISE LAYOUT")
              ]),
              _createElementVNode("p", null, "成立于2015年，已发展为多业务于一体的科技成长型企业集团")
            ], -1),
            _createElementVNode("div", { class: "module1" }, [
              _createElementVNode("div", { class: "module1-flex-7" }, [
                _createElementVNode("div", {
                  class: "hover-item",
                  style: {"border-radius":"20px 0px 0px 20px"}
                }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "icon"
                  }),
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "icon-hover"
                  }),
                  _createElementVNode("h2", null, "互联金融"),
                  _createElementVNode("p", null, "驱动互联金融服务"),
                  _createElementVNode("p", null, "助力金融机构可持续增长")
                ])
              ]),
              _createElementVNode("div", { class: "module1-flex-7" }, [
                _createElementVNode("div", { class: "hover-item" }, [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "icon"
                  }),
                  _createElementVNode("img", {
                    src: _imports_3,
                    class: "icon-hover"
                  }),
                  _createElementVNode("h2", null, "商业模型"),
                  _createElementVNode("p", null, "基于千亿级数据"),
                  _createElementVNode("p", null, "建立商业模型")
                ])
              ]),
              _createElementVNode("div", { class: "module1-flex-10" }, [
                _createElementVNode("div", {
                  class: "hover-item",
                  style: {"border-radius":"0px 20px 0px 0px","margin-bottom":"10px"}
                }, [
                  _createElementVNode("img", {
                    src: _imports_4,
                    class: "icon"
                  }),
                  _createElementVNode("img", {
                    src: _imports_5,
                    class: "icon-hover"
                  }),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { style: {"margin-top":"0"} }, "大数据SaaS"),
                    _createElementVNode("p", null, "AI招财店长门店智慧运营"),
                    _createElementVNode("p", null, "一站式智能SaaS解决方案")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "hover-item",
                  style: {"border-radius":"0px 0px 20px 0px"}
                }, [
                  _createElementVNode("img", {
                    src: _imports_6,
                    class: "icon"
                  }),
                  _createElementVNode("img", {
                    src: _imports_7,
                    class: "icon-hover"
                  }),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", { style: {"margin-top":"0"} }, "AI算力"),
                    _createElementVNode("p", null, "规划5000P超大算力"),
                    _createElementVNode("p", null, "智算无限商业可能")
                  ])
                ])
              ])
            ], -1)
          ])),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 20 }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, "闭环生态系统，实现可持续的业务增长和创新发展"),
                _createElementVNode("span", null, "ECOSYSTEM")
              ]),
              _createElementVNode("p", null, "以SaaS服务为基础,数据算力为支撑,商业模型为驱动")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_col, {
                span: 11,
                class: "centent-l-box"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: _unref(apiUrl) + '/images/' + businessList.value[0]?.url
                    }, null, 8, _hoisted_5),
                    _createElementVNode("p", null, _toDisplayString(businessList.value[0]?.title), 1),
                    _createElementVNode("p", {
                      innerHTML: businessList.value[0]?.describe
                    }, null, 8, _hoisted_6)
                  ]),
                  _createVNode(Consult)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                span: 12,
                offset: 1,
                class: "centent-r-box"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _unref(apiUrl) + '/images/' + businessList.value[1]?.url,
                    style: {"width":"100%","height":"auto"}
                  }, null, 8, _hoisted_7),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(businessList.value[2]?.title), 1),
                  _createElementVNode("p", {
                    innerHTML: businessList.value[1]?.describe,
                    style: {"margin-bottom":"80px"}
                  }, null, 8, _hoisted_9),
                  _createElementVNode("img", {
                    src: _unref(apiUrl) + '/images/' + businessList.value[2]?.url,
                    style: {"width":"100%","height":"auto"}
                  }, null, 8, _hoisted_10),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(businessList.value[2]?.title), 1),
                  _createElementVNode("p", {
                    innerHTML: businessList.value[2]?.describe
                  }, null, 8, _hoisted_12)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "bg-module" }, "让科技 · 联结起美好生活", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 20 }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "title" }, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, "品牌咨询"),
                _createElementVNode("span", null, "OFFICIALLY")
              ]),
              _createElementVNode("p", null, "以SaaS服务为基础,数据算力为支撑,商业模型为驱动")
            ], -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(News, {
      news: news.value,
      style: {"margin-bottom":"150px"}
    }, null, 8, ["news"]),
    _createVNode(Footer)
  ]))
}
}

})